module.exports = __webpack_public_path__ + "/images/testimonial-ichamar.aef5074.jpg";